export function formatPreview(n, len) {
  if (n?.length <= len) return n;
  return n?.substring(0, Math.min(n?.length, len));
}
